import * as React from "react";
import { cn } from "../../lib/utils";

interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
}

export function Dialog({ open, onOpenChange, title, children }: DialogProps) {
  if (!open) return null;

  return (
    <div className="dialog-overlay" onClick={() => onOpenChange(false)} role="presentation">
      <div
        className={cn("dialog-content")}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="dialog-header">
          <h2>{title}</h2>
          <button className="btn btn-ghost" onClick={() => onOpenChange(false)}>
            Close
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
